export interface SalarioInputData {
  readonly salario: string;
  readonly estado: string;
}

export interface SalarioResultsType {
  readonly percentilNacional: number;
  readonly percentilEstadual: number;
  readonly rankingEstado: number;
  readonly posicaoRanking: string;
  readonly comparacaoDeputado: number;
  readonly comparacaoMagistrado: number;
  readonly profissoes: Array<ComparacaoProfissao>;
  readonly simulacaoInvestimento: SimulacaoInvestimento;
  readonly salarioMedioEstado: number;
  readonly salarioMedioBrasil: number;
  readonly nomeEstado: string;
}

export interface ComparacaoProfissao {
  readonly nome: string;
  readonly icone: string;
  readonly salarioMedio: number;
  readonly percentualUsuario: number;
}

export interface SimulacaoInvestimento {
  readonly aporteMenusal: number;
  readonly em10Anos: number;
  readonly em25Anos: number;
  readonly em30Anos: number;
}

export interface EstadoBrasil {
  readonly value: string;
  readonly label: string;
  readonly regiao: 'NORTE' | 'NORDESTE' | 'SUDESTE' | 'SUL' | 'CENTRO_OESTE';
}

export interface DadosProfissao {
  readonly medico: number;
  readonly enfermeiro: number;
  readonly professor: number;
}

// Mensagens de validação
export const ValidationMessages = {
  SALARIO_OBRIGATORIO: "Informe o seu salário mensal.",
  ESTADO_OBRIGATORIO: "Selecione o estado onde você vive.",
  SALARIO_INVALIDO: "Salário deve ser maior que zero.",
  SALARIO_MUITO_ALTO: "Salário muito alto. Verifique o valor informado.",
  ERRO_CALCULO: "Erro no cálculo. Verifique os dados informados.",
} as const;